import axios from "axios";

export async function forgotPassword(email: string): Promise<void> {
  const { data } = await axios.post("/users/forgot-password", {
    email,
  });
  return data;
}
